import { makeStyles } from "@material-ui/core/styles";
import { preDefinedThemeColor } from "../preDefinedColor";
import Login from "../../images/illustration.png";
import ForgotPassword from "../../images/Forgot_Password.png";


export const useStyles = makeStyles((theme) => ({
  root: {
    width: "100vw",
    minHeight: "100vh",
    display: "flex!important",
    justifyContent: "center",
    alignItems: "center",
    ['@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)']: {
      height: '100vh',
      overflow: 'auto',
      minHeight: 750,
    },
  },
  contentWrapper: {
    backgroundColor: "rgba(249,249,249,1) !important",
    width: "65vw",
    maxWidth: "1250px",
    minHeight: "700px",
    maxHeight: "1000px",
    borderRadius: "30px!important",
    position: "relative",
    overflow: "hidden",
    padding: "50px",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("lg")]: {
      width: "65vw",
      maxWidth: "1250px",
      // minHeight: "75vh",
      maxHeight: "1000px",
    },
    [theme.breakpoints.down("md")]: {
      width: "85vw",
      minHeight: "75vh",
    },
    [theme.breakpoints.down("sm")]: {
      width: "90vw",
      minHeight: "85vh",
      padding: "30px 20px",
    },
    "&:before": {
      content: '""',
      position: "absolute",
      bottom: 0,
      left: 50,
      width: "100%",
      height: "1rem",
      display: "block",
    },
    "&:after": {
      content: '""',
      display: "block",
      position: "absolute",
      top: "0%",
      right: "0",
      width: "100%",
      height: "100%",
      backgroundImage: "url(" + Login + ")",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right",
      backgroundSize: "600px auto",
      [theme.breakpoints.down("lg")]: {
        backgroundSize: "500px auto",
      },
      [theme.breakpoints.down("md")]: {},
      [theme.breakpoints.down("sm")]: {
        backgroundSize: "110% auto",
        opacity: "0.1",
      },
    },
    ['@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)']: {
        maxHeight: '100vh',
    },
  },
  contentWrapperNotFound: {
    width: "65vw",
    maxWidth: "1250px",
    minHeight: "75vh",
    maxHeight: "700px",
    borderRadius: "30px!important",
    position: "relative",
    overflow: "hidden",
    padding: "50px 50px 0 50px",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("lg")]: {
      width: "65vw",
      maxWidth: "1250px",
      // minHeight: "75vh",
      maxHeight: "774px",
    },
    [theme.breakpoints.down("md")]: {
      width: "85vw",
      minHeight: "75vh",
    },
    [theme.breakpoints.down("sm")]: {
      width: "90vw",
      minHeight: "85vh",
      padding: "30px 20px",
    },
  },
  contentWrapperForgotten: {
    "&:after": {
      backgroundImage: "url(" + ForgotPassword + ")",
    },
  },
  boxCircle: {
    width: "200%",
    position: "absolute",
    display: "block",
    borderRadius: "100%",
    backgroundColor: "#fff",
    bottom: 10,
    right: -60,
    "&:after": {
      content: '""',
      paddingBottom: "100%",
      display: "block",
    },
  },
  logoWrapper: {
    position: "relative",
    zIndex: 2,
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
    },
  },
  formWrapper: {
    margin: "auto 0 !important",
  },
  boxWrapper: {
    margin: "120px auto",
    padding: "0 40px",
    maxWidth: "400px",
    position: "relative",
    zIndex: 1,
    "& .MuiFormLabel-root": {
      fontWeight: 500,
      fontSize: "1.25em",
    },
    [theme.breakpoints.down("sm")]: {
      margin: "30px auto",
      padding: "0",
    },
  },
  titleWrap: {
    margin: theme.spacing(8, 0),
    [theme.breakpoints.up("lg")]: {
      margin: theme.spacing(0, 0, 8, 0),
    },
  },
  titleWrapForgotten: {
    margin: theme.spacing(3, 0),
    [theme.breakpoints.up("lg")]: {
      margin: theme.spacing(0, 0, 9, 0),
    },
  },
  title: {
    textAlign: "center",
    color: "#000",
    fontWeight: 500,
    "&.MuiTypography-h5": {
      fontWeight: 500,
    },
  },
  errorMessage: {
    color: "rgb(230,56,38)",
    fontSize: "12px",
    fontWeight: 500,
    textAlign: "center",
    marginTop: "1.5em",
    marginBottom: "-2rem",
  },
  errorMessageForgotten: {
    color: preDefinedThemeColor.red,
    fontSize: "13px!important",
    textAlign: "center",
    marginTop: "20px!important",
  },
  successMessage: {
    color: preDefinedThemeColor.green,
    fontSize: "13px!important",
    textAlign: "center",
    marginTop: "20px!important",
  },
  input: {
    "& .MuiInput-input": {
      padding: "10px",
    },
  },
  forgotPassword: {
    cursor: "pointer",
    color: "#BBBEC5!important",
    fontWeight: 500,
  },
  titleNotFound: {
    "&.MuiTypography-h5": {
      fontWeight: 500,
    },
    fontWeight: 700,
    margin: "1em 0 0.5em!important",
    color: "#000",
    textAlign: "center",
  },
  titleNoAccess: {
    fontSize: '25px !important',
  },
  secondaryTitle: {
    textAlign: "center",
    fontSize: "2.75em !important",
    color: "rgb(189, 192, 199)",
    marginBottom: "20px!important",
  },
  secondaryTitleNoAccess: {
    fontSize: '15px !important',
  },
  noAccessImg: {
    height: "400px",
  },
  errorImg: {
    height: "500px",
    margin: "0 auto",
    display: "block",
    [theme.breakpoints.down("sm")]: {
      height: "auto",
      width: "100%",
    },
  },
  errorBack: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
    position: "absolute",
    left: "50%",
    bottom: 25,
    transform: "translate(-50%, 0)",
    fontSize: "1.2rem",
    display: 'flex',
    alignAtems: 'center',
    "& .MuiSvgIcon-root": {
      marginRight: theme.spacing(1),
    },
  },
  centerLoader: {
    textAlign: 'center',
  },
  primaryButtonXl: {
    borderRadius: `${theme.spacing(3)}px !important`,
    padding: `${theme.spacing(1, 5)}px !important`,
    fontSize: "1.275rem !important",
    height: "auto !important",
  },
  noAccessWrapper: {
    textAlign: 'center',
    backgroundColor: '#ffffff',
    padding: theme.spacing(10, 5),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(4, 2),
    },
  },
  helperTextWrapper: {
    color: "rgba(0,0,0,.54)",
    marginTop: theme.spacing(.75),
  },
  helperTextLabel: {
    fontSize: 13,
    fontWeight: 'bold',
  },
  helperTextList: {
    padding: '0 !important',
  },
  helperTextListItem: {
    fontSize: 13,
    padding: '0 !important',
  },
  isValid: {
    color: 'green',
  },
  isInvalid: {
    color: 'red',
  }, 
}));
